
import './Loading.css'; // Import the CSS file for loading styles

const Loading = () => {
  return (
    <div className="loading-container">
      {/* Replace 'logo.gif' with your loading image */}
      {/* <img src="/logo.gif" alt="Loading" className="loading-image" /> */}
      <iframe src="https://lottie.host/embed/cdbe067c-cb3a-44ef-8f35-a4cbd4f8981b/JmmxW9N5mZ.json">

      </iframe>
      
    </div>
    
  );
};

export default Loading;
